'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PlanValidator = function () {
  function PlanValidator(form, values, translations) {
    _classCallCheck(this, PlanValidator);

    var _jQValidator = void 0;
    var props = void 0;
    if (typeof form !== 'string') {
      console.error('Enter a valid form\'s selector as first parameter');
    } else {
      //* Get the default properties from plan-validator-defaults.js
      if (Object.assign) {
        props = Object.assign({}, planValidGlobalDefaults);
      } else {
        //! IE11
        props = this.objAssign({}, planValidGlobalDefaults);
      }

      //* Get values if they are provided
      if (values) {
        for (var prop in values) {
          if (prop !== 'texts') props[prop] = values[prop];
        }
      }

      //* Get translations object if they are provided
      if (translations) {
        for (var _prop in translations) {
          props.texts[_prop] = translations[_prop];
        }
      }

      this.form = form;
      this.props = props;
      this._jQValidator = _jQValidator;
      this.init();
    }
  }

  _createClass(PlanValidator, [{
    key: 'init',
    value: function init() {
      this.translateLabels();
      this.controlCPBlock();
      this.initjQValidator();
      if (this.props.type === 2) {
        this.controlUserType();
      }
    }

    //* Translate labels of the form. They must have a class called '.js-label-[name of var]'

  }, {
    key: 'translateLabels',
    value: function translateLabels() {
      var labels = this.props.texts[this.props.lang].labels;
      var $form = $(this.form);
      for (var prop in labels) {
        if (labels.hasOwnProperty(prop)) {
          var $label = $form.find('.js-label-' + prop);
          if ($label.length > 0) {
            $label.text(labels[prop]);
          }
        }
      }
    }

    //* Controls the 2 types of "Código Postal" fields block

  }, {
    key: 'controlCPBlock',
    value: function controlCPBlock() {
      var that = this;
      var market = this.props.market;
      var $form = $(this.form);
      var setCPValue = this.setCPValue;
      if (market === 'pyb' || market === 'can') {
        market = 'es';
      }
      $form.find('.js-' + market).addClass('visible');
      //! THE CP BLOCK OF THE OTHER MARKETS MUST BE REMOVED TO PREVENT SENDING IT TWICE OR MORE TIMES!!
      $form.find('.js-cp-block').not('.js-' + market).remove();
      if (market === 'pt') {
        $form.find('.js-cp1').on('keyup', function (e) {
          if ($(this).val().length === 4) {
            $form.find('.js-cp2').trigger('focus');
          }
          setCPValue(that);
        });
        $form.find('.js-cp2').on('keyup', function (e) {
          setCPValue(that);
        });
      }
    }

    //* Method for setting an CP valid value

  }, {
    key: 'setCPValue',
    value: function setCPValue(that) {
      var $form = $(that.form);
      var val1 = $form.find('.js-cp1').val();
      var val2 = $form.find('.js-cp2').val();
      $form.find('.js-field-cp').val(val1 + '-' + val2);
      if ($form.find('.js-field-cp').hasClass('error')) {
        $form.find('.js-field-cp').valid();
      }
    }

    //* Instantiating the jQuery validator

  }, {
    key: 'initjQValidator',
    value: function initjQValidator() {
      var _this = this;

      var $form = $(this.form);

      var errors = this.props.texts[this.props.lang].errors;

      var errorElement = this.props.errorElement;

      var errorClass = this.props.errorClass;

      var errorPlacement = this.props.errorPlacement;

      var submitHandler = this.props.submitHandler;

      // Basic common rules for Simple Person Form
      var personalDataRules = {
        name: {
          required: true,
          requiredStrict: true,
          alphabetical: true,
          noConsecutiveLetters: true,
          noSpecialCharacters: true,
          miniumOneVocal: true,
          minlength: 3,
          messages: {
            required: errors.required,
            requiredStrict: errors.required,
            alphabetical: errors.alphabetical,
            noConsecutiveLetters: errors.noConsecutiveLetters,
            noSpecialCharacters: errors.noSpecialCharacters,
            miniumOneVocal: errors.miniumOneVocal,
            minlength: errors.min3characters
          }
        },
        surname1: {
          required: true,
          requiredStrict: true,
          alphabetical: true,
          noConsecutiveLetters: true,
          noSpecialCharacters: true,
          miniumOneVocal: true,
          minlength: 3,
          messages: {
            required: errors.required,
            requiredStrict: errors.required,
            alphabetical: errors.alphabetical,
            noConsecutiveLetters: errors.noConsecutiveLetters,
            noSpecialCharacters: errors.noSpecialCharacters,
            miniumOneVocal: errors.miniumOneVocal,
            minlength: errors.min3characters
          }
        },
        surname2: {
          alphabetical: true,
          messages: {
            alphabetical: errors.alphabetical
          }
        },
        email: {
          emailstrict: true,
          required: true,
          requiredStrict: true,
          email: false,
          messages: {
            required: errors.required,
            emailstrict: errors.email,
            requiredStrict: errors.required
          }
        }
      };

      // Basic common rules for Companies & Self Employed Form
      var businessDataRules = {
        userType: {
          required: true,
          requiredStrict: true,
          messages: {
            required: errors.required,
            requiredStrict: errors.required
          }
        },
        position: {
          required: true,
          requiredStrict: true,
          messages: {
            required: errors.required,
            requiredStrict: errors.required
          }
        },
        companyName: {
          required: true,
          requiredStrict: true,
          messages: {
            required: errors.required,
            requiredStrict: errors.required
          }
        },
        fleetSize: {
          required: true,
          requiredStrict: true,
          messages: {
            required: errors.required,
            requiredStrict: errors.required
          }
        },
        city: {
          required: true,
          requiredStrict: true,
          messages: {
            required: errors.required,
            requiredStrict: errors.required
          }
        }

        // Combining common rules if necessary
        // const allRules = (this.props.type === 2) ? Object.assign({}, personalDataRules, businessDataRules) : Object.assign({}, personalDataRules);

      };var allRules = void 0;

      if (this.props.type === 2) {
        if (Object.assign) {
          allRules = Object.assign({}, personalDataRules, businessDataRules);
        } else {
          //! IE 11
          allRules = this.objAssign({}, personalDataRules);
          allRules = this.objAssign(allRules, businessDataRules);
        }
      } else {
        if (Object.assign) {
          allRules = Object.assign({}, personalDataRules);
        } else {
          // ! IE 11
          allRules = this.objAssign({}, personalDataRules);
        }
      }

      $form.each(function (index, element) {
        var $thisForm = $(element);
        _this._jQValidator = $thisForm.validate({
          errorElement: errorElement,
          errorClass: errorClass,
          errorPlacement: errorPlacement,
          submitHandler: submitHandler
        });
        for (var prop in allRules) {
          var $elemById = $thisForm.find('.js-field-' + prop);
          $elemById.rules('add', allRules[prop]);
        }
      });

      if (this.props.fieldDealer) {
        $form.find('.js-field-dealer').rules('add', {
          required: true,
          messages: {
            required: errors.dealer
          }
        });
      }

      $.validator.addMethod('alphabetical', planValidRules.alphabetical);
      $.validator.addMethod('requiredStrict', planValidRules.requiredStrict);
      $.validator.addMethod('emailstrict', planValidRules.emailStrict);
      $.validator.addMethod('noConsecutiveLetters', planValidRules.noConsecutiveLetters);
      $.validator.addMethod('noSpecialCharacters', planValidRules.noSpecialCharacters);
      $.validator.addMethod('miniumOneVocal', planValidRules.miniumOneVocal);

      var $fieldCP = $form.find('.js-field-cp');
      var $fieldPhone = $form.find('.js-field-phone');
      var $fieldPhoneFixed = $form.find('.js-field-fixed-phone');
      var $fieldPhoneMobile = $form.find('.js-field-mobile-phone');

      if (this.props.market === 'pyb' || this.props.market === 'can') {
        $.validator.addMethod('cpES_AD', planValidRules.cpES_AD);
        $.validator.addMethod('phoneES_AD', planValidRules.telfES_AD);
        $.validator.addMethod('phoneESFixed', planValidRules.phoneESFixed);
        $.validator.addMethod('phoneESMobile', planValidRules.phoneESMobile);
        $fieldCP.rules('remove');
        $fieldCP.rules('add', { cpES_AD: true, messages: { required: errors.required, cpES_AD: errors.cp } });
        $fieldPhone.rules('remove');
        $fieldPhone.rules('add', { phoneES_AD: true, messages: { required: errors.required, phoneES_AD: errors.phone } });
        $fieldPhoneFixed.rules('remove');
        $fieldPhoneFixed.rules('add', { phoneESFixed: true, messages: { required: errors.required, phoneESFixed: errors.phone } });
        $fieldPhoneMobile.rules('remove');
        $fieldPhoneMobile.rules('add', { phoneESMobile: true, messages: { required: errors.required, phoneESMobile: errors.phone } });
      }

      if (this.props.market === 'pt') {
        $.validator.addMethod('cpPT', planValidRules.cpPT);
        $.validator.addMethod('phonePT', planValidRules.telfPT);
        $.validator.addMethod('phonePTMobile', planValidRules.phonePTMobile);
        $fieldCP.rules('remove');
        $fieldCP.rules('add', { cpPT: true, messages: { required: errors.required, cpPT: errors.cp } });
        $fieldPhone.rules('remove');
        $fieldPhone.rules('add', { phonePT: true, messages: { required: errors.required, phonePT: errors.phone } });
        $fieldPhoneMobile.rules('remove');
        $fieldPhoneMobile.rules('add', { phonePTMobile: true, messages: { required: errors.required, phonePTMobile: errors.phoneMobile } });
      }

      // BUSINESS VALIDATION METHODS
      if (this.props.type === 2) {
        if (this.props.market === 'pyb' || this.props.market === 'can') {
          this.businessESRules();
        }
        if (this.props.market === 'pt') {
          this.businessPTRules();
        }
      }
    }
  }, {
    key: 'objAssign',
    value: function objAssign(a, b) {
      var objs = [a, b];
      var result = objs.reduce(function (r, o) {
        Object.keys(o).forEach(function (k) {
          r[k] = o[k];
        });
        return r;
      }, {});
      return result;
    }
  }, {
    key: 'businessESRules',
    value: function businessESRules() {
      var errors = this.props.texts[this.props.lang].errors;
      $.validator.addMethod('nifNie', planValidRules.nifNie);
      $.validator.addMethod('cif', planValidRules.cif);
      // Self-employed
      var $fieldNif = $('.js-field-nif');
      $fieldNif.rules('remove');
      $fieldNif.rules('add', {
        required: true,
        nifNie: true,
        messages: {
          required: errors.required,
          nifNie: errors.nifNie
        }
      });
      // Company
      var $fieldCif = $('.js-field-cif');
      var $fieldPosition = $('.js-field-position');
      $fieldCif.rules('remove');
      $fieldCif.rules('add', {
        required: true,
        cif: true,
        messages: {
          required: errors.required,
          cif: errors.cif
        }
      });
      $fieldPosition.rules('remove');
      $fieldPosition.rules('add', {
        required: true,
        alphabetical: true,
        messages: {
          required: errors.required,
          alphabetical: errors.alphabetical
        }
      });
      // Fleet Size
      /* const $fieldFleetSize = $('.js-field-fleetSize');
      $fieldFleetSize.rules('remove');
      $fieldFleetSize.rules('add', {
        required: true,
        messages: {
          required: errors.required
        }
      }) */
    }
  }, {
    key: 'businessPTRules',
    value: function businessPTRules() {
      var errors = this.props.texts[this.props.lang].errors;
      $.validator.addMethod('ccOrBi', planValidRules.ccOrBi);
      $.validator.addMethod('nipc', planValidRules.nipc);
      // Self-employed
      var $fieldNif = $('.js-field-nif');
      $fieldNif.rules('add', {
        ccOrBi: true,
        required: true,
        messages: {
          required: errors.required,
          ccOrBi: errors.ccOrBi
        }
      });
      // Company
      var $fieldCif = $('.js-field-cif');
      var $fieldPosition = $('.js-field-position');
      $fieldCif.rules('add', {
        nipc: true,
        required: true,
        messages: {
          required: errors.required,
          nipc: errors.nipc
        }
      });
      $fieldPosition.rules('remove');
      $fieldPosition.rules('add', {
        required: true,
        alphabetical: true,
        messages: {
          required: errors.required,
          alphabetical: errors.alphabetical
        }
      });
    }
  }, {
    key: 'changeFieldsByUserType',
    value: function changeFieldsByUserType(props) {
      var val = $('.js-field-userType:checked').val();

      if (typeof val !== 'undefined') {
        var classToShow = void 0,
            classToHide = void 0;
        switch (val) {
          // SELF-EMPLOYED
          case '1':
            classToShow = '.js-selfemployed';
            classToHide = '.js-company';
            var $fieldCif = $('.js-field-cif');
            var $fieldPosition = $('.js-field-position');
            $fieldCif.val('');
            $fieldPosition.val('');
            break;
          // COMPANY
          case '2':
            classToShow = '.js-company';
            classToHide = '.js-selfemployed';
            var $fieldNif = $('.js-field-nif');
            $fieldNif.val('');
            break;
        }
        $(classToShow).addClass('visible');
        $(classToHide).removeClass('visible');
      }
    }
  }, {
    key: 'controlUserType',
    value: function controlUserType() {
      var _this2 = this;

      var changeFields = function changeFields() {
        return _this2.changeFieldsByUserType(_this2.props);
      };
      changeFields();
      $('.js-field-userType').on('change', changeFields);
    }
  }, {
    key: 'jQValidator',
    get: function get() {
      if (typeof this._jQValidator !== 'undefined') {
        return this._jQValidator;
      }
    }
  }]);

  return PlanValidator;
}();